import { render, staticRenderFns } from "./analysisAdvisorPostReport.vue?vue&type=template&id=507923b1&scoped=true"
import script from "./analysisAdvisorPostReport.vue?vue&type=script&lang=js"
export * from "./analysisAdvisorPostReport.vue?vue&type=script&lang=js"
import style0 from "./analysisAdvisorPostReport.vue?vue&type=style&index=0&id=507923b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507923b1",
  null
  
)

export default component.exports